import {
  Breadcrumbs,
  Inline,
  Stack,
  Switcher,
  Typography,
  useViewport,
} from '@omnipresentgroup/design-system';
import { useNavigate } from 'react-router';

import { MergeIntegrationWidget } from '../../features/merge-integration';
import { XeroIntegrationWidget } from '../../features/xero-integration';

export const INTEGRATIONS_PAGE_TITLE = 'Integrations';

export const IntegrationsPage = () => {
  const navigate = useNavigate();

  const { isPhone, isTablet } = useViewport();

  const PageHeader = () => {
    return (
      <Inline justify="space-between" minH={40} align="center">
        <Typography as="h2" hideParagraphSpacing size="24" weight="medium">
          {INTEGRATIONS_PAGE_TITLE}
        </Typography>
      </Inline>
    );
  };

  return (
    <>
      <Stack gap="16">
        <Breadcrumbs
          crumbs={[
            { id: 'home', title: 'Home', onClick: () => navigate('/') },
            {
              id: 'integrations',
              title: INTEGRATIONS_PAGE_TITLE,
              active: true,
            },
          ]}
        />
        <PageHeader />
      </Stack>
      <Switcher isStacked={isPhone || isTablet}>
        <MergeIntegrationWidget />
        <XeroIntegrationWidget />
      </Switcher>
    </>
  );
};
